export default __webpack_public_path__ + "static/media/FleetManager.9c6710b2.svg";